export const FEATURE_STORE_GATE = 'Growth:FeatureStore';